import {
  ChangeDetectionStrategy,
  Component,
  computed,
  EventEmitter,
  input,
  InputSignal,
  OnInit,
  Output,
  Signal,
  signal,
  WritableSignal,
} from '@angular/core';
import {
  TsBadgeModule,
  TsButtonModule,
  TsDateRangeComponent,
  TsDividerComponent,
  TSIconModule,
  TsOverlayModule,
} from 'tsui';
import { ReportPeriodUtils } from '../../utils/report-period.utils';
import moment from 'moment/moment';
import { ReportPeriod } from '../../models';
import { TsDateRange } from 'tsui/lib/ts-date-range/ts-date-range.component';

@Component({
  selector: 'report-period-selector',
  standalone: true,
  imports: [TsBadgeModule, TsButtonModule, TsOverlayModule, TsDateRangeComponent, TSIconModule, TsDividerComponent],
  templateUrl: './report-period-selector.component.html',
  styleUrl: './report-period-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportPeriodSelectorComponent implements OnInit {
  readonly reportPeriod: InputSignal<ReportPeriod> = input.required();
  readonly loading: InputSignal<boolean> = input(false);

  @Output() reportPeriodChanged = new EventEmitter<ReportPeriod>();

  protected readonly reportPeriodPresets = ReportPeriodUtils.buildReportPeriodPresets();
  protected readonly initialReportPeriodRange: Signal<TsDateRange> = computed(() => {
    if (this.reportPeriod()) {
      return {
        range: {
          start: moment(this.reportPeriod().start_date),
          end: this.reportPeriod().end_date ? moment(this.reportPeriod().end_date) : null,
        },
      };
    }
  });

  private newReportPeriod: WritableSignal<ReportPeriod>;

  ngOnInit() {
    this.newReportPeriod = signal(this.reportPeriod());
  }

  getReportPeriodBadgeLabel(reportPeriod: ReportPeriod): string {
    if (reportPeriod.key === 'custom') {
      return `${moment(reportPeriod.start_date).format('MMM YYYY')} - ${moment(reportPeriod.end_date).format('MMM YYYY')}`;
    }
    return ReportPeriodUtils.reportPeriodLabels[reportPeriod.key];
  }

  updateNewReportPeriod(newRange: TsDateRange) {
    if (!newRange?.range?.start) {
      this.newReportPeriod.set({ ...this.reportPeriod() });
    } else {
      const start_date = moment(newRange?.range.start).format('YYYY-MM-DD');
      const end_date = newRange?.range?.end ? moment(newRange?.range.end).format('YYYY-MM-DD') : start_date;

      this.newReportPeriod.set({
        key: newRange.id ?? 'custom',
        start_date,
        end_date,
      });
    }
  }

  applyNewReportPeriod() {
    this.reportPeriodChanged.emit(this.newReportPeriod());
  }
}
